import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import { PageBody as _PageBody, BoxProps, Button, Link } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { ContactSupport } from '../employeeDashboard/ContactSupport'
import { useOptionalOrgId } from '../orgDashboard/useOrgId'
import { orgRootPath } from '../orgDashboard/organization/useOrg'
import { Breadcrumbs } from './Breadcrumb'
import { useLocation } from 'react-router'

const GoToRoot = () => {
  const orgId = useOptionalOrgId()
  const location = useLocation()
  if (!orgId || location.pathname === orgRootPath(orgId)) return null
  return (
    <Button component={Link} to={orgRootPath(orgId)} sx={{ mt: 2 }}>
      <ArrowBackIosIcon fontSize="inherit" /> Back
    </Button>
  )
}

export const PageBody = ({ children, ...boxProps }: BoxProps) => {
  const orgId = useOptionalOrgId()
  return (
    <_PageBody {...boxProps}>
      {orgId && <Breadcrumbs root={{ route: orgRootPath(orgId), label: 'Home' }} type="admin" />}
      {children}
      <GoToRoot />
      <ContactSupport admin={Boolean(orgId)} />
    </_PageBody>
  )
}
